import * as DialogPrimitive from "@radix-ui/react-dialog"
import React from "react"
import { cn } from '@/utils/index'

export const DialogDescription = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Description>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className={cn("text-muted-foreground text-sm dark:text-neutral-300", className)}
    {...props}
  />
))
DialogDescription.displayName = DialogPrimitive.Description.displayName
